import React from "react";
import {Alert, Button, styled, TableCell, TableContainer, Tooltip} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import BatchProgressLinearWithLabel from "../utils/BatchProgressLinearWithLabel";
import {convertDateToTimeString} from "../utils/cert-helper";
import makeStyles from "@mui/styles/makeStyles";
import {lookupTerminology, TerminologyList} from "../utils/terminology";
import {PortalUrl} from "../utils/portal-urls";

const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
})
const StyledAlert = styled(Alert)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    paddingTop: '10px',

})
const StyledLastImportBox = styled(Box)({
    wordBreak: 'break-all',
    lineHeight: '21px',
    '& .textSpan': {
        color: '#005cbfcc'
    }
})
const StyledCacheDataSourceSpan = styled('span')({
    borderStyle: 'dashed',
    fontSize: 15,
    fontWeight: 'normal',
    borderWidth: '1px',
    borderRadius: '5px',
    padding: '0 5px 0 5px',
    marginLeft: '10px'
})
const StyledTitleSpan = styled('span')({
    color: 'rgba(51,71,81,0.75)',
})
export const CustomATage = (props) => {
    const {path, size} = props;
    return <a href={path} target='_blank' style={{fontSize: size}}>{path}</a>
}


const useStyles = makeStyles((theme) => ({
    externalSourceName: {
        color: '#005cbfcc', fontWeight: 'bold', fontSize: 17,
        '& button': {marginLeft: 10},
        // '& span': {marginLeft: 10}
    },
    runningProcessWrapper: {
        background: '#607d8b15', padding: 10,
        '& h4': {color: "#555555", fontSize: 16}

    },
}));

// Amendment #1 A5 value sets appended from the registry, so the listing tracks it automatically.
const dbs = ["NPPESNPI", "NUCCSpecialty", "ServDescription", "Suffix", "OrgType",
    ...TerminologyList.map(t => t.source)];
const caches = ["PlaceApi", "PhoneValidationApi"];

export function splitPath(paths) {
    let cleanPath = paths.replace('[', '');
    cleanPath = cleanPath.replace(']', '');
    return cleanPath.split(',');
}

export default function ExternalSourceTable(props) {
    const classes = useStyles();
    const allSourceData = props.allSourceData || {};
    const navigate = useNavigate();

    const navigateTo = (source) => {
        // The A5 value sets share one route keyed by name; everything else has a path of its own.
        const terminology = lookupTerminology(source);
        navigate(terminology
            ? PortalUrl.ExternalSource.Terminology.getHome(terminology.key)
            : `/externalSource/${source}`);
    }

    console.log("allSourceData: ", allSourceData);


    return (
        <TableContainer sx={{mt: '10px', '& .MuiTableCell-root': {paddingLeft: '10px', paddingRight: '10px'}}}>
            <Table sx={{m: 0}}>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data Source</StyledTableCell>
                        <StyledTableCell>Info</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {dbs.map((source, index) => {
                        if (allSourceData[source] && allSourceData[source].lastCompletedLog) {
                            const data = allSourceData[source];
                            return (<TableRow key={`ds-${source}`}>
                                <TableCell>
                                    <div className={classes.externalSourceName}>
                                        <StyledTitleSpan>{source}</StyledTitleSpan>
                                        <Tooltip title={`Manage ${source}`} arrow>
                                            <Button variant='text' color='primary' onClick={() => navigateTo(source)}
                                                    size='small'>Manage</Button>
                                        </Tooltip>
                                    </div>
                                </TableCell>
                                {/*<TableCell sx={{ width: '120px'}}>{data.totalCount}</TableCell>*/}
                                <TableCell sx={{maxWidth: '450px'}}>
                                    <StyledLastImportBox>
                                        <div style={{fontWeight: "bold", color: "#555555"}}>
                                            TOTAL RECORDS: &nbsp; <span className="textSpan">{data.totalCount}</span>
                                        </div>
                                        <div>
                                            Last Import Time: &nbsp;
                                            <span
                                                className="textSpan">{convertDateToTimeString(data.lastCompletedLog.createdTs)}</span>
                                        </div>
                                        {/*<div>*/}
                                        {/*    Import Status:&nbsp;*/}
                                        {/*    <span className="textSpan">{data.lastCompletedLog.completed*/}
                                        {/*        ? <Chip icon={<CheckCircleIcon />} variant='outlined' label="COMPLETED" size='small' color='success' sx={{'& span': {paddingTop: '4px'}}}/>*/}
                                        {/*        : <Chip icon={<CancelRoundedIcon />} variant='outlined' label="NOT COMPLETED" size='small' color='warning' sx={{'& span': {paddingTop: '4px'}}}/>}*/}
                                        {/*        </span>*/}
                                        {/*</div>*/}
                                        <div>
                                            Last Imported Records Count:&nbsp;
                                            <span
                                                className="textSpan">{data.lastCompletedLog.importedRecordCount}</span>
                                        </div>
                                        <div>
                                            Data Source:
                                            <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                                                {splitPath(data.lastCompletedLog.dataPath).map((path, i) => (
                                                    <li key={i}><span className="textSpan"
                                                                      style={{color: '#334751'}}><CustomATage
                                                        size='14px' path={path}/></span></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </StyledLastImportBox>
                                    {data.runningLog && data.runningLog.map( p => (
                                        <div key={p.id}>
                                            <div className={classes.runningProcessWrapper}>
                                                <hr/>
                                                <h4>Running import process</h4>
                                                <BatchProgressLinearWithLabel batchId={p.batchId}/>
                                                <div>
                                                    Description:
                                                    <span className="currentProcess">{p.description}</span>
                                                </div>
                                                <div>
                                                    Data Source:
                                                    <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                                                        {splitPath(p.dataPath).map((path, i) => (
                                                            <li key={i} className="name">{path}</li>
                                                        ))}
                                                    </ul>
                                                    {/*<span className="currentProcess">{splitPath(data.lastCompletedLog.dataPath).map((path, i) => (*/}
                                                    {/*    <li key={i} className="name">{path}</li>*/}
                                                    {/*))}</span>*/}
                                                </div>
                                            </div>
                                            <br/>
                                        </div>
                                        ))
                                    }
                                </TableCell>
                            </TableRow>);
                        } else {
                            return (
                                <TableRow key={`missing-${source}`}>
                                    <TableCell className={classes.externalSourceName}>
                                        <StyledTitleSpan>{source}</StyledTitleSpan> <Tooltip title={`Manage ${source}`}
                                                                                             arrow>
                                        <Button variant='text' color='primary' onClick={() => navigateTo(source)}
                                                size='small'>Manage</Button>
                                    </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <StyledLastImportBox>
                                            <div style={{fontWeight: "bold", color: '#555555'}}> TOTAL RECORDS: &nbsp;
                                                <span className="textSpan">0</span></div>
                                        </StyledLastImportBox>
                                    </TableCell>
                                </TableRow>);
                        }
                    })}

                    {caches.map((source, index) => {
                        const cachedCount = allSourceData[source] && allSourceData[source].totalCount || 0;
                        return (
                            <TableRow key={`cache-${source}`}>
                                <TableCell className={classes.externalSourceName}>
                                    <StyledTitleSpan>{source}</StyledTitleSpan>
                                    <StyledCacheDataSourceSpan>cache</StyledCacheDataSourceSpan>
                                </TableCell>
                                <TableCell>
                                    <StyledLastImportBox>
                                        <div style={{fontWeight: "bold", color: '#555555'}}> TOTAL CACHED
                                            RECORDS: &nbsp; <span
                                                className="textSpan">{allSourceData[source].totalCount}</span></div>
                                    </StyledLastImportBox>
                                </TableCell>
                            </TableRow>
                        )
                    })}

                </TableBody>
            </Table>
        </TableContainer>
    )
}
